import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  noResultFound: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(5)
  },
  noresult: {
    width: '15%',
    [theme.breakpoints.down('sm')]: {
      width: '25%'
    }
  },
  noResults: {
    marginTop: 16,
    fontWeight: 500,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  }
}))
export default useStyles
